import { Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { Info, Offers } from '@volkswagen-onehub/icons-core';

import React from 'react';
import { highlightMatch } from '../../../helpers/highlight-match-helpers';
import { getSortedDatosEconomicos } from '../../../service/api/get-ofertas';
import { Oferta, OfertaDatoEconomico } from '../../../types/oferta-types';
import { OptionCard } from './core/option-card';

interface Props {
	oferta?: Oferta;
	isActive?: boolean;
	hasError?: boolean;
	showDetails?: boolean;
	highlight?: string;
	onSelect?: () => void;
}

export function OfertaOptionCard(props: Props) {
	const { oferta, isActive = false, hasError = false, showDetails = false, highlight, onSelect } = props;
	if (!oferta) return null;

	const datosEconomicos = getSortedDatosEconomicos(oferta);

	if (!datosEconomicos || datosEconomicos.length === 0) return null;

	const query = isActive ? undefined : highlight;

	return (
		<OptionCard
			icon={<Offers />}
			selectable={!!onSelect}
			isActive={isActive}
			hasError={hasError}
			onSelect={onSelect}
			dataAttributes={{ 'data-id': oferta.id }}
		>
			<Text bold>OFERTA</Text>
			<Text>
				{highlightMatch(oferta.carline.name.toUpperCase(), query)}{' '}
				{highlightMatch(oferta.configuracion.motorizacion?.name, query)}
			</Text>
			{showDetails && (
				<Text appearance={TokenTextAppearance.copy100}>
					{highlightMatch(oferta.titulo, query)}
					{oferta.descripcion ? (
						<>
							<br />
							{highlightMatch(oferta.descripcion, query)}
						</>
					) : null}
				</Text>
			)}
			{datosEconomicos.map((datoEconomico: OfertaDatoEconomico, index: number) => (
				<div key={index}>
					<Text appearance={TokenTextAppearance.copy100}>
						<Info variant="small" /> {datoEconomico.modalidad} {datoEconomico.precio}€{' '}
						{datoEconomico.periodicidad !== 'pago-unico' ? (
							<>
								{datoEconomico.periodicidad} {datoEconomico.plazos} plazos con{' '}
								{datoEconomico.tipoFinanciacion?.replace('-', ' ')} TIN {datoEconomico.tin || '-'}% TAE{' '}
								{datoEconomico.tae || '-'}%
							</>
						) : (
							'(pago único)'
						)}
					</Text>
				</div>
			))}
		</OptionCard>
	);
}
